
import { usePageTracking } from "@/hooks/usePageTracking";
import NewBrandLandingPage from "@/components/landing/NewBrandLandingPage";
import { useAuth } from "@/contexts/AuthContext";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Index = () => {
  usePageTracking();
  const { isAuthenticated, isLoading } = useAuth();
  const navigate = useNavigate();

  console.log('[Index] State:', { isAuthenticated, isLoading });

  // Redirect authenticated users to dashboard
  useEffect(() => {
    if (isAuthenticated && !isLoading) {
      console.log('[Index] Redirecting authenticated user to dashboard');
      navigate("/dashboard", { replace: true });
    }
  }, [isAuthenticated, isLoading, navigate]);

  // Show loading while auth state is being determined
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    );
  }

  // Don't render landing page if user is authenticated (will redirect)
  if (isAuthenticated) {
    return null;
  }

  return <NewBrandLandingPage />;
};

export default Index;
